// useLocation hook
import { useLocation } from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";
// useFetch hook
import useFetch from "../hook/useFetch";
// components
import CategoryNav from "../components/CategoryNav";
import Product from "../components/Product";
import ProductGrid from "../components/ProductGrid";
import ProductGridSkeleton from "../components/ui/ProductGridSkeleton";
import StateMessage from "../components/ui/StateMessage";

export default function Search() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchTerm = searchParams.get("query");
  // get product based on search term
  const { data, isLoading, error } = useFetch(
    `/products/products?search=${searchTerm}`
  );

  const results = data ?? [];

  return (
    <div className="mb-[30px] pt-40 md:pt-40 lg:pt-4 xl:pt-0">
      <div className="container mx-auto">
        <div className="flex gap-x-[30px]">
          <CategoryNav />
          <div className="w-full">
            <div className="py-3 text-xl uppercase text-center lg:text-left">
              {isLoading
                ? `Searching for ${searchTerm}…`
                : results.length > 0
                ? `${results.length} results for ${searchTerm}`
                : `No results found for ${searchTerm}`}
            </div>
            {isLoading ? (
              <ProductGridSkeleton />
            ) : error ? (
              <StateMessage
                icon={FiAlertTriangle}
                title="Something went wrong"
                message="We couldn't run your search. Please try again later."
              />
            ) : (
              <ProductGrid>
                {results.map((product) => (
                  <Product product={product} key={product._id} />
                ))}
              </ProductGrid>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
